
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { NoWinPosterState, PosterManager, } from "../../independent/poster/PosterManager";
import { SanBackground } from "../../background/SanBackground";
import { JumpingWildCollector } from "../../independent/collector/JumpingWildCollector";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { ReelOverlay } from "../../background/ReelOverlay";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { IdleWinPresentation } from "../idle/IdleWinPresentation";
import {SanGameModuleConfig} from "../../../SanGameModuleConfig";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TotalWinPresentation extends Presentation {

    private totalWinAmount:number = 0;
    private won:number = 0;
    private indx:number = 0

    // #241
    private _winBelowStake: boolean = false;
    private playBadRound:boolean = false;
    private delayed:boolean = false;
    private clickedss:boolean = false;

    public setParsedGamedData(data:SanParsedGameData):void{
        this.totalWinAmount = data.totalWin;
        this.won = data.singleWin;
        SplashController.instance.setResultTotal({ fs:data.numberOfFreespinsPlayed!,jwData:data.sanJumpData});

        const badWinLvl:number = data.sanJumpData.length == 1 ? 100*0.15 : data.sanJumpData.length == 2 ? 200*0.20 : 2000*0.25;
        this.playBadRound = (data.totalWin/ parseFloat(data.rawData!.playedBetValue!)) < badWinLvl;
        // #241
        this._winBelowStake = SanGameModuleConfig.featurePrice.isWinBelowStake();
    }

    public checkForActivation(data:SanParsedGameData):boolean{ return !data.rawData.brokeTheBank && data.mode !== GameMode.NORMAL && data.nextMode === GameMode.NORMAL};

    preStart():void{
        this.clickedss = false;
        this.delayed = false;
        this.indx = -1;
        SanEngineManager.setFSSymbol("",0);
        RevealerManager.setFSSymbol("",0);
        SoundManager.SwitchFStoMain(!this._winBelowStake); // #241
    }

    public getPresentation(){
        SlotGame.api.events.trigger(APIEvent.SKIP)

        if(!this.delayed){
            this.delayed = true;
            this.pTimeline.to(this,this.won ? 1 : 0.35, {});
        }

        if(this.playBadRound ){
            this.pTimeline.add(PosterManager.instance.play(NoWinPosterState.NO_WIN,undefined,{config:{
                animationName: IdleWinPresentation.getNextNoPoster
            }}));
            this.pTimeline.add(() => PosterManager.instance.stopTotal());
            this.pTimeline.to(this,0.45,{});
            this.playBadRound = false;

            return;
        }

        if(this.indx == -1){
            this.pTimeline.to(this, this.won > 0 ? 0.5 : 0.2,{});
            this.indx = 0;
        }

        if(!this.indx){
            this.pTimeline.add(() => {
                SlotGame.keypad.setZeroBetSpinCounter(-1);

                EventHandler.dispatchEvent(new GameEvent(SpinEvent.DONE));
                // SanBackground.instance.fsSpineBG(0);
                SanBackground.instance.playAtmosphere(0);
                PosterManager.instance.playTotalWin(this.totalWinAmount, this._winBelowStake);
                ReelOverlay.instance.changeAlpha(0, 0.4);
                SanBackground.instance.changeBgBlackness(0.4,0);
                SanBackground.instance.stopCheering();
            },0.2)
            this.pTimeline.add(SplashController.instance.play(3,() => this.clicked()),0.2)
            this.indx = 1;
        }else{
            
            JumpingWildController.instance.cleanItems();
            JumpingWildCollector.instance.reset();
            PosterManager.instance.stopTotalWin();
            PosterManager.instance.setBlackScreenAlpha(0);

            SanBackground.instance.restoreOverlay(3);

            this.pTimeline.add(SanBackground.instance.moveBG(false));
            this.pTimeline.to(this,0.4,{});
            this.PresentationState.set(PresentationState.INACTIVE);
        }
    }

    clicked():void{
        if(!this.clickedss){
            this.clickedss = true;
            SplashController.instance.stop();
            this.pTimeline.totalProgress(1);
            SanGameModuleConfig.featurePrice.reset();
        }
    }
}